const GenericErrorPage = () => {
  return (
    <div id="error-page">
      <p>Something went wrong!</p>
    </div>
  );
};

export default GenericErrorPage;
